import React from 'react';

import { cn } from '@/lib/utils';
import { ExternalLink } from 'lucide-react';

import { TableTextInput } from './table-text-input';

export interface TableUrlInputProps {
  value: string | null;
  onChange: (value: string | null) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  autoFocus?: boolean;
  displayValue: string | null;
  isEditing: boolean;
  /** Whether this field was recently modified (for highlighting) */
  isRecentlyModified?: boolean;
}

/**
 * URL input with RTL direction and external link icon
 * Special display mode with clickable external link
 */
export const TableUrlInput: React.FC<TableUrlInputProps> = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  disabled,
  autoFocus,
  displayValue,
  isEditing,
  isRecentlyModified = false,
}) => {
  return (
    <>
      {isEditing ? (
        <TableTextInput
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      ) : (
        <div
          className={cn(
            'flex h-full w-full items-center space-x-2 truncate rounded-none px-2 text-sm',
            isRecentlyModified
              ? 'border-l-2 border-blue-500 bg-blue-50'
              : 'bg-transparent'
          )}
        >
          <span className="truncate" dir="rtl">
            {typeof displayValue === 'string' ? displayValue : '—'}
          </span>
          {typeof displayValue === 'string' &&
            displayValue &&
            displayValue !== '—' && (
              <a
                href={displayValue}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
                onClick={(e) => e.stopPropagation()}
              >
                <ExternalLink size={16} color="black" />
              </a>
            )}
        </div>
      )}
    </>
  );
};
